<template>
  <div>
    <div class="md-layout md-alignment-center-center" v-if="isLoaded">
      <div class="md-layout-item">
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-checkbox v-model="inPerson">本人填寫</md-checkbox>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>代表人名稱</label>
              <md-input :disabled="inPerson" v-model="submitter_name"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>關係</label>
              <md-input :disabled="inPerson" v-model="relationship"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <label>個人（個人舒適度）</label>
            <slider :value="ors.personal" @update="value => {change({type: 'personal', value})}"></slider>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <label>人際（家庭、親密關係）</label>
            <slider :value="ors.interpersonal" @update="value => {change({type: 'interpersonal', value})}"></slider>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <label>社會（工作、學校、友誼）</label>
            <slider :value="ors.social" @update="value => {change({type: 'social', value})}"></slider>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <label>整體（整體幸福感）</label>
            <slider :value="ors.overall" @update="value => {change({type: 'overall', value})}"></slider>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <md-button class="md-raised md-primary" @click="submit">提交</md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import OrsCharts from '@/components/Patient/OrsCharts'
import Ors from '@/components/ORSTest/ORS'
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'
import urls from '@/urls'

export default {
  mixins: [ Ors ],
  data () {
    return {
      isLoaded: false,
      _patientID: null,
      _recordID: null
    }
  },
  props: [],
  components: {
    PageTitle, OrsCharts
  },
  computed: {
    ...mapState('ors', {
      ors: state => state.content
    })
  },
  created () {
    this._patientID = this.$route.params.patientID
    this._recordID = this.$route.params.recordID
    this.resetValues()
    this.getOrsTest()
  },
  methods: {
    async getOrsTest () {
      let req = await axios.get(urls({route: `ors-test/by-patient/${this._patientID}/${this._recordID}`}))
      let data = req.data.data
      // this.change({type: 'personal', value: data.content.personal})
      // this.change({type: 'interpersonal', value: data.content.interpersonal})
      // this.change({type: 'social', value: data.content.social})
      // this.change({type: 'overall', value: data.content.overall})
      this.loadOrsValues(data.content)
      this.isLoaded = true
    },
    async submit () {
      let req = await axios.put(urls({route: `ors-test/by-patient/${this._patientID}/${this._recordID}`}), {
        content: this.ors
      })
      if (req.status === 200) {
        alert('提交成功')
      }
    },
    ...mapMutations('ors', {
      resetValues: 'resetValues',
      loadOrsValues: 'loadValues'
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Patient/OrsTestPatient.vue